import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class MyProviderInvitationsPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            all: [],
            statuses: [],
            status: null,
            statusDossiers: null,
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
            orderBy : {value: 'date', dir: 'asc', text: 'Por fecha - Mas Antiguos' },
            orderOptions : [
                {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
                {value: 'date', dir: 'asc', text: 'Por Fecha - Mas Antiguos' },
                {value: 'fiscal_name', dir: 'asc', text: 'Por Nombre A - Z' },
                {value: 'fiscal_name', dir: 'desc', text: 'Por Nombre Z - A' },
            ],
        };
        this.loadStatus = this.loadStatus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    changeOrderOption(option){
        this.setState({orderBy: option}, function(){
            this.getAll();
        });
    }

    componentDidMount() {

        this.getStatuses()
        this.getAll()
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value, page: 1}, function () {
            this.getAll();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAll();
        });
    }

    async getStatuses() {
        const res = await axios.get('/api/invitations/status')
        let data = res.data;

        if (this.props.provider) {
            data = data.filter(status => status.id !== 'Draft');
        }

        this.setState({statuses: data});

        var statusDossiers = [];

        this.state.statuses.map((s) => {
            statusDossiers = [...statusDossiers, []];
        });

        this.setState({statusDossiers: statusDossiers})
    }

    showAll(){
        this.setState({all: [], page: 1, status: null, index: null}, () => {
            this.getAll();
        });
    }

    loadStatus(index){
        const status = this.state.statuses[index];
        this.setState({all: [], page: 1, status: status.id}, () => {
            this.getAll();
        });
    }

    async getAll(){
        var url = '/api/providers/invitations';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.status!=null){
            query.append('status', this.state.status);
        }

        if(this.state.orderBy.value != ''){
            query.append('orderBy', this.state.orderBy.value);
            query.append('orderByDir', this.state.orderBy.dir);
        }

        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;

        const res = await axios.get(url);
        const data = res.data.data;
        this.setState({all: data, total: res.data.total});
    }

    render() {
        const { lang } = this.context;
        return (
            <>
            {this.props.dashboard=="false" &&
                <div className="row justify-content-end">
                    <div className="col-4">
                        <div className="input-icon">
                        <input
                            onChange={this.handleChange}
                            name="search"
                            type="text"
                            className="form-control"
                            placeholder="Buscar invitaciones" />
                        <span>
                            <i className="flaticon2-search-1 text-primary icon-md"></i>
                        </span>
                        </div>
                    </div>
                </div>
            }
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.invitaciones')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} {lang.get('messages.invitaciones_recibidas')}</span>
                    </h3>
                    <div className="card-toolbar">
                        <ul className="nav nav-pills nav-pills-sm nav-dark">
                            <li className="nav-item ml-0">
                                <a href={"#ts_all"} className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==null ? "active" : ""}`} onClick={() => this.showAll()} >{lang.get('messages.todos')}</a>
                            </li>

                            {this.state.statuses.map((status, i) => {
                                return <li key={i} className="nav-item ml-0" onClick={() => this.loadStatus(i)} >
                                    <a href={"#ts_" + i } className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==status.id ? "active" : ""}`}>{lang.get('messages.'+status.name.toLowerCase())}</a>
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
                <div className="card-body pt-1">
                    {this.props.dashboard=="false" &&
                        <div className="dropdown text-right">
                            <button className="btn btn-secondary btn-sm dropdown-toggle text-primary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {lang.get('messages.ordenar')} {this.state.orderBy.text}
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                {this.state.orderOptions.map((option, i) => {
                                    return <a onClick={() => this.changeOrderOption(option)} key={i} className="dropdown-item" href="#">{ option.text }</a>
                                })}
                            </div>
                        </div>
                    }
                    <div className="table-responsive">
                        <table className="table table-borderless table-vertical-center">
                            <tbody>
                                {this.state.all.map((d, index) => {
                                    return <tr key={index}>
                                        <td className="pl-0 py-5">
                                            <div className="symbol symbol-40">
                                                <div className="symbol-label bg-primary text-white font-weight-bolder">
                                                { d.client != null ? d.client?.fiscal_name[0] : d.name[0] }
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/invitation/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                    { d.client != null ? d.client?.fiscal_name : d.name }
                                                </div>
                                                <span className="text-dark-50 font-weight-bold font-size-sm">{d.client?.identity} : { d.client != null ? d.client?.rfc.toUpperCase() : '' }</span>
                                            </a>
                                        </td>
                                        <td>
                                            <span className="text-dark-50 font-weight-bold">{d.dossier?.title}</span>
                                        </td>
                                        <td>
                                            <span className={'py-2 w-70px text-center font-size-xs badge badge-'+d.dossier?.status.toString().toLowerCase()}>{lang.get('messages.'+d.dossier?.status.toLowerCase())} </span>
                                        </td>
                                        <td className="text-left text-nowrap" style={{width:'1px'}}>
                                            <a href={"/invitation/" + d.id}>
                                                <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.total}</span>
                                                <span className="text-muted font-weight-bold ml-4">{lang.get('messages.documentos')}</span>
                                            </a>
                                        </td>
                                        <td className="text-right">
                                            <a href={"/invitation/" + d.id}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </a>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                    { this.props.dashboard == "true" ?
                        <div className="text-right">
                            <a className="text-primary" href="/providers/invitations">{lang.get('messages.ver_todos')}</a>
                        </div>
                    :
                        <div></div>
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default MyProviderInvitationsPanel;

if (document.getElementById('MyProviderInvitationsPanel')) {
    ReactDOM.render(<MyProviderInvitationsPanel />, document.getElementById('MyProviderInvitationsPanel'));
}
